function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M32 2.54A29.46 29.46 0 112.54 32 29.5 29.5 0 0132 2.54M32 0a32 32 0 1032 32A32 32 0 0032 0z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2.54,
  d: "M32 42.78V25.99"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.3 28.68h11.4L32 21.22l-5.7 7.46z",
  fill: "currentColor"
});

function SvgArrowCircleUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij4KICAgIDx0aXRsZT5hcnJvdy1jaXJjbGUtdXA8L3RpdGxlPgogICAgPHBhdGggZD0iTTMyLDIuNTRBMjkuNDYsMjkuNDYsMCwxLDEsMi41NCwzMiwyOS41LDI5LjUsMCwwLDEsMzIsMi41NE0zMiwwQTMyLDMyLDAsMSwwLDY0LDMyLDMyLDMyLDAsMCwwLDMyLDBaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KICAgIDxsaW5lIHgxPSIzMiIgeTE9IjQyLjc4IiB4Mj0iMzIiIHkyPSIyNS45OSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyLjU0Ii8+CiAgICA8cGF0aCBkPSJNMjYuMywyOC42OEgzNy43TDMyLDIxLjIybC01LjcsNy40NloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4=";
export { SvgArrowCircleUp as ReactComponent };